module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAb0lEQVR42u3asQ0AMAwCQaTsv3Aa0mQLztIvcC1O2ywXAAAAAAAAAAAAAAAArB0AAAAAAAAAAAAAAAAANPecLgUAAAAAAAAAAAAAAAAAv7VVDAAAAAAAAAAAAAAAAAAAeJQEAAAAAAAAAAAAAGCsB1Dr1c5s/8eIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/South-Ossetia.png
// module id = bV8b
// module chunks = 0 62 63